import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-po-finish',
  templateUrl: './po-finish.component.html',
  styleUrls: ['./po-finish.component.css']
})
export class PoFinishComponent implements OnInit {
    p2PofinishKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PofinishKeyno = this.stateService.getStateParams()['p2_pofinish_keyno'];
    }

    private async loadMenu() {
        if (!!this.p2PofinishKeyno) {
            this.menu = (await this.datatask.Post(180, { p2_pofinish_keyno: this.p2PofinishKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    p2_pofinish_keyno: string;
    portal_user_name: string;
    reg_datetime: string;
    pofinishprodnbr: string;
    p2_pofinishprod_keyno: string;
}
